import { PlusOutlined, EditOutlined, DeleteOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import { Button, Modal, Table } from "antd";
import { useEffect, useState } from "react";
import Footer from "../../../components/Footer";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar";
import AddTaxe from "./AddTaxe";
import { toast } from "react-toastify";
import confirm from "antd/es/modal/confirm";
import axiosInstance from "../../../variables/api/axiosInstance";
import ActionDropdown from "../../production/components/ActionDropdown";

const Taxes = () => {
  const [taxes, setTaxes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedTaxe, setSelectedTaxe] = useState(null);

  const handleShow = (edit, taxe = null) => {
    setEditMode(edit);
    setSelectedTaxe(taxe);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setEditMode(false);
    setSelectedTaxe(null);
  };

  const deleteTaxe = (codeId) => {
    axiosInstance
      .delete(`/api/taxe/${codeId}`)
      .then(() => {
        setTaxes((prev) => prev.filter((t) => t.codeId !== codeId));
        toast.success("Taxe supprimée avec succès");
      })
      .catch((err) => {
        console.error("Erreur lors de la suppression :", err);
        toast.error("Erreur lors de la suppression de la taxe");
      });
  };

  const showDeleteConfirm = (codeId) => {
    confirm({
      title: "Êtes-vous sûr de vouloir supprimer cette taxe ?",
      icon: <ExclamationCircleFilled />,
      content: "Cette action est irréversible.",
      okText: "Oui",
      okType: "danger",
      cancelText: "Annuler",
      onOk() {
        deleteTaxe(codeId);
      },
    });
  };

  const loadTaxes = () => {
    axiosInstance
      .get(`/api/taxe`)
      .then((res) => {
        const list = res.data.filter((t) => t.activeData);
        // Trie pour que la plus récente soit en haut
        const sorted = [...list].sort((a, b) => b.createdAt?.localeCompare(a.createdAt));
        setTaxes(sorted);
      })
      .catch((err) => {
        console.error("Erreur de chargement :", err);
        toast.error("Erreur lors du chargement des taxes");
      });
  };

  useEffect(() => {
    loadTaxes();
  }, []);

  const columns = [
    {
      title: "Nom",
      dataIndex: "libelleTaxe",
      key: "libelleTaxe",
    },
    {
      title: "Valeur",
      dataIndex: "valeur",
      key: "valeur",
      render: (val) => `${val} %`,
    },
    {
      title: "Garanties",
      dataIndex: "garanties",
      key: "garanties",
      render: (list) => (
        <ul style={{ marginBottom: 0 }}>
          {list.map((g) => (
            <li key={g.codeId}>{g.nom}</li>
          ))}
        </ul>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <ActionDropdown
          actions={[
            {
              key: "edit",
              label: "Modifier",
              icon: <i className="bx bx-edit-alt" />,
              onClick: () => handleShow(true, record),
            },
            {
              key: "delete",
              label: "Supprimer",
              icon: <i className="bx bx-trash" />,
              danger: true,
              onClick: () => showDeleteConfirm(record.codeId),
            },
          ]}
        />
      ),
    },
  ];

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <SideBar currentMenu="TARIFICATION" />
        <div className="layout-page">
          <NavBar />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => handleShow(false)}
                style={{ marginBottom: 16 }}
              >
                Ajouter une nouvelle taxe
              </Button>

              <div className="card">
                <h5 className="card-header">Paramétrage de taxes</h5>
                <Table
                  columns={columns}
                  dataSource={taxes}
                  rowKey="codeId"
                  pagination={{ pageSize: 10 }}
                />
              </div>

              <Modal open={showModal} footer={null} onCancel={handleClose}>
                <AddTaxe
                  show={showModal}
                  handleClose={handleClose}
                  editMode={editMode}
                  codeId={selectedTaxe?.codeId}
                  selectedTaxe={selectedTaxe}
                  taxes={taxes}
                  onSaveSuccess={loadTaxes}
                  onSaveError={() =>
                    toast.error("Erreur lors de la sauvegarde de la taxe")
                  }
                />
              </Modal>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Taxes;
